import { useTranslation } from '@shared/core';
import { useFundBalanceSavingsCopy } from '@shared/utils/cashFund/useFundBalanceSavingsCopy';

type HoneymoonFundBalanceCopyArgs = Readonly<{
  fundBalanceDisplay: string;
  fundCouponSavingsDisplay?: string;
  fundCouponPercentOff?: number;
}>;

export const useHoneymoonFundBalanceCopy = ({ fundBalanceDisplay, fundCouponSavingsDisplay, fundCouponPercentOff }: HoneymoonFundBalanceCopyArgs) => {
  const { tq } = useTranslation('yourRegistry');
  const body = useFundBalanceSavingsCopy({ fundBalanceDisplay, fundCouponSavingsDisplay, fundCouponPercentOff });

  return {
    headline: tq`Use your cash fund to book stays`,
    body,
    ctaLabel: tq`Explore stays`,
  };
};
